"use strict";var a=require("./transformToPlaybackCase.cjs");exports.transformToPlaybackTitleCase=function(r,s){return void 0===s&&(s=0),a.transformToPlaybackCase("TITLE",r,s)};
//# sourceMappingURL=transformToPlaybackTitleCase.cjs.map
